import React from 'react';

const Title = ({ titleValue }) => (
    <h1 className="product__title block__title-h2">{titleValue}</h1>
);

export default Title;
